const API_PREFIX = "/schedule-expiry-notifications";

export const getScheduleExpiryNotificationsEndpoint = () => `${API_PREFIX}`;
export const getScheduleExpiryNotificationsCountEndpoint = () => `${API_PREFIX}/count`;
export const dismissScheduleExpiryNotificationEndpoint = (id: string) => `${API_PREFIX}/${id}/dismiss`;
export const optOutScheduleExpiryNotificationEndpoint = (staffId: string) => `${API_PREFIX}/${staffId}/opt-out`;
export const scheduleExpiryNotificationsSettingsEndpoint = () => `/settings/schedule-expiry-notifications`;
